import { render, staticRenderFns } from "./DeleteUsers.vue?vue&type=template&id=ce31363a&scoped=true&"
import script from "./DeleteUsers.vue?vue&type=script&lang=js&"
export * from "./DeleteUsers.vue?vue&type=script&lang=js&"
import style0 from "./DeleteUsers.vue?vue&type=style&index=0&id=ce31363a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce31363a",
  null
  
)

export default component.exports